var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreySearch = function SvgGreySearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.128 22-6.283-6.268v-.993l-.34-.352a8.18 8.18 0 1 1 .88-.88l.352.34h.995L22 20.126 20.128 22ZM8.19 2.533a5.655 5.655 0 1 0 5.655 5.656A5.662 5.662 0 0 0 8.19 2.533Z",
    fill: "#8F8F8F",
    fillRule: "nonzero"
  })));
};
export default SvgGreySearch;